'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n\tpadding-top: 30px;\n\tpadding-bottom: 30px;\n\tz-index: 995;\n\toverflow: visible;\n'], ['\n\tpadding-top: 30px;\n\tpadding-bottom: 30px;\n\tz-index: 995;\n\toverflow: visible;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n\t0% {\n\t\topacity: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t}\n'], ['\n\t0% {\n\t\topacity: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t}\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n\t0% {\n\t\topacity: 1;\n\t}\n\t100% {\n\t\topacity: 0;\n\t}\n'], ['\n\t0% {\n\t\topacity: 1;\n\t}\n\t100% {\n\t\topacity: 0;\n\t}\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n\toverflow-y: visible;\n\tposition: relative;\n\tborder: none;\n\tbackground: white;\n\ttransition: all 0.6s;\n\tborder-radius: ', ';\n\tleft: 50%;\n\tz-index: 999;\n\topacity: ', ' !important;\n\tvisibility: ', ';\n\ttransform: ', ';\n\t', ';\n\t', ';\n\twidth: 345px;\n\tmargin-left: ', 'px;\n\t@media (min-width: ', ') {\n\t\twidth: 460px;\n\t\tmargin-left: ', 'px;\n\t}\n\n\t@media (min-width: ', ') {\n\t\twidth: ', 'px;\n\t\tmargin-left: ', 'px;\n\t}\n\n\t@media (min-width: ', ') {\n\t\twidth: ', 'px;\n\t\tmargin-left: ', 'px;\n\t}\n'], ['\n\toverflow-y: visible;\n\tposition: relative;\n\tborder: none;\n\tbackground: white;\n\ttransition: all 0.6s;\n\tborder-radius: ', ';\n\tleft: 50%;\n\tz-index: 999;\n\topacity: ', ' !important;\n\tvisibility: ', ';\n\ttransform: ', ';\n\t', ';\n\t', ';\n\twidth: 345px;\n\tmargin-left: ', 'px;\n\t@media (min-width: ', ') {\n\t\twidth: 460px;\n\t\tmargin-left: ', 'px;\n\t}\n\n\t@media (min-width: ', ') {\n\t\twidth: ', 'px;\n\t\tmargin-left: ', 'px;\n\t}\n\n\t@media (min-width: ', ') {\n\t\twidth: ', 'px;\n\t\tmargin-left: ', 'px;\n\t}\n']),
    _templateObject5 = _taggedTemplateLiteral(['animation: 0.5s ', ' ease-in-out'], ['animation: 0.5s ', ' ease-in-out']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _screenSize = require('../../constants/screenSize');

var _sizes = require('../../constants/sizes');

var _header = require('./header');

var _header2 = _interopRequireDefault(_header);

var _content = require('./content');

var _content2 = _interopRequireDefault(_content);

var _footer = require('./footer');

var _footer2 = _interopRequireDefault(_footer);

var _radius = require('../../constants/radius');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ModalLayout = _styledComponents2.default.div(_templateObject);

var fadeIn = (0, _styledComponents.keyframes)(_templateObject2);

var fadeOut = (0, _styledComponents.keyframes)(_templateObject3);

var ModalComponent = _styledComponents2.default.div(_templateObject4, _radius.Radius.small, function (_ref) {
	var visible = _ref.visible;
	return visible ? 1 : 0;
}, function (_ref2) {
	var visible = _ref2.visible;
	return visible ? 'visible' : 'hidden';
}, function (_ref3) {
	var visible = _ref3.visible;
	return visible ? 'scale(1)' : 'scale(0.9)';
}, function (_ref4) {
	var animate = _ref4.animate;
	return animate && (0, _styledComponents.css)(_templateObject5, fadeIn);
}, function (_ref5) {
	var animateOut = _ref5.animateOut;
	return animateOut && (0, _styledComponents.css)(_templateObject5, fadeOut);
}, 345 / 2 * -1, _screenSize.ScreenSize.sm, 460 / 2 * -1, _screenSize.ScreenSize.md, function (_ref6) {
	var size = _ref6.size;
	return getModalSize(_screenSize.ScreenSize.md, size);
}, function (_ref7) {
	var size = _ref7.size;
	return getModalSize(_screenSize.ScreenSize.md, size) / 2 * -1;
}, _screenSize.ScreenSize.lg, function (_ref8) {
	var size = _ref8.size;
	return getModalSize(_screenSize.ScreenSize.lg, size);
}, function (_ref9) {
	var size = _ref9.size;
	return getModalSize(_screenSize.ScreenSize.lg, size) / 2 * -1;
});

function getModalSize(screenSize, propsSize) {
	var width = void 0;

	switch (screenSize) {
		case _screenSize.ScreenSize.md:
			width = propsSize === _sizes.Sizes.lg ? 610 : 460;
			break;
		case _screenSize.ScreenSize.lg:
		case _screenSize.ScreenSize.xl:
			switch (propsSize) {
				case _sizes.Sizes.md:
					width = 610;
					break;
				case _sizes.Sizes.lg:
					width = 780;
					break;
				case _sizes.Sizes.xl:
					width = 960;
					break;
				case _sizes.Sizes.xxl:
					width = 1024;
					break;
				default:
					width = 460;
					break;
			}
			break;
	}

	return width;
}

var Modal = function (_React$Component) {
	_inherits(Modal, _React$Component);

	function Modal() {
		_classCallCheck(this, Modal);

		return _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));
	}

	_createClass(Modal, [{
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				ModalLayout,
				null,
				_react2.default.createElement(
					ModalComponent,
					{ visible: this.props.visible, size: this.props.size, animate: this.props.animate, animateOut: this.props.animateOut },
					_react2.default.createElement(_header2.default, { closeEvent: this.props.closeEvent, noCloseBtn: this.props.noCloseBtn }),
					_react2.default.createElement(
						_content2.default,
						null,
						this.props.items
					),
					_react2.default.createElement(_footer2.default, { text: this.props.footerText, closeEvent: this.props.closeEvent, actionButtons: this.props.actionButtons })
				)
			);
		}
	}]);

	return Modal;
}(_react2.default.Component);

exports.default = Modal;